<div
  class="grad-circle"
  [ngClass]="
    gradient.gradient != null ? 'grad-circle-' + gradient.gradient : ''
  "
></div>
<p class="gradient-num">
  <ng-container *ngIf="gradient.gradient == 0">
    < {{ gradient.max }}<ng-container *ngIf="suffix">{{ suffix }}</ng-container>
  </ng-container>
  <ng-container
    *ngIf="gradient.gradient > 0 && gradient.gradient < numGradients - 1"
  >
    {{ gradient.min }}<ng-container *ngIf="suffix">{{ suffix }}</ng-container> -
    {{ gradient.max }}<ng-container *ngIf="suffix">{{ suffix }}</ng-container>
  </ng-container>
  <ng-container *ngIf="gradient.gradient == numGradients - 1">
    >= {{ gradient.min
    }}<ng-container *ngIf="suffix">{{ suffix }}</ng-container>
  </ng-container>
</p>
